import _ from 'lodash';

import COMMON_IMPORTS from './common.imports';

import './nextTimes.bundle.scss';

import nextTimesWrapperComponentMod from './next-times/next-times-wrapper.component';
import defaultConfigs from './common.config';
import defaultRuns from './common.run';
import translationServiceMod from './common/translation.service';

let mod = angular.module('nextTimesMain', _.union(
  COMMON_IMPORTS,
  defaultConfigs.imports,
  defaultRuns.imports,
  [
    nextTimesWrapperComponentMod,
    translationServiceMod
  ]
))

.controller('NextTimesBundleController', function ($scope, $compile, $element, $log, TranslationService) {
  TranslationService.waitForTranslations().finally(() => {
    const person = $element[0].dataset['person'];
    const service = $element[0].dataset['service'];
    const location = $element[0].dataset['location'];
    const voucher = $element[0].dataset['voucher'];

    $scope.is_frontpage = $element[0].dataset['frontpage'] != null;
    
    const voucherTemplate = voucher != null ? `voucher="${voucher}"` : "";

    let elem = null;
    if (person != null) {
      elem = `<next-times-wrapper p-type="person" person-id="${person}" time-amount="5" ${voucherTemplate}></next-times-wrapper>`;
    }
    else if (location != null) {
      elem = `<next-times-wrapper p-type="location" location-id="${location}" time-amount="5" ${voucherTemplate}></next-times-wrapper>`;
    }
    else if (service != null) {
      elem = `<next-times-wrapper p-type="service" service-id="${service}" time-amount="5" ${voucherTemplate}></next-times-wrapper>`;
    }
    else {
      elem = '<next-times-wrapper is-frontpage="is_frontpage"></next-times-wrapper>';
    }

    $log.debug("Constructed next times", elem);

    const anElement = angular.element(elem);
    $compile(anElement)($scope);

    // Render the next times widget
    $element.append(anElement);
  });
})
;

mod = defaultConfigs(mod);
mod = defaultRuns(mod);

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/nextTimes.bundle.js